import type { ReservationSectionId } from '@/wabunka-src/common/features/Reservation/core/requiredFields/sections';
import { buildReservationSectionParams, type ReservationSectionParams } from '@/wabunka-src/common/utils/googleAnalytics/common/reservationSection';
import { sendWabunkaGAEvent } from '@/wabunka-src/common/utils/googleAnalytics/googleAnalytics';

export type ReservationSectionViewParams = ReservationSectionParams;

/** 発火タイミング：新動線でセクションが初めて開いたとき。Edit で開き直しても再送しない。自動完了で通過した S2 は開かないので発火しない */
export const sendGAWabunkaReservationSectionViewEvent = (sectionId: ReservationSectionId) => {
  sendWabunkaGAEvent('reservation_section_view', buildReservationSectionParams(sectionId));
};
